module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view'), _vm._v(" "), _c('tabbar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowFooter),
      expression: "isShowFooter"
    }],
    staticClass: "tabbar_btm",
    staticStyle: {
      "background": "#fff"
    },
    attrs: {
      "id": "appTabbar"
    }
  }, [_c('tabbar-item', {
    attrs: {
      "link": "/invoiceCard/"
    }
  }, [_c('img', {
    staticClass: "dsel_img",
    attrs: {
      "slot": "icon",
      "src": require("./assets/img/f1.png")
    },
    slot: "icon"
  }), _vm._v(" "), _c('img', {
    staticClass: "sel_img",
    attrs: {
      "slot": "icon",
      "src": require("./assets/img/f1_a.png")
    },
    slot: "icon"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("发票名片")])]), _vm._v(" "), _c('tabbar-item', {
    attrs: {
      "link": "/index/"
    }
  }, [_c('img', {
    staticClass: "dsel_img",
    attrs: {
      "slot": "icon",
      "src": require("./assets/img/f2.png")
    },
    slot: "icon"
  }), _vm._v(" "), _c('img', {
    staticClass: "sel_img",
    attrs: {
      "slot": "icon",
      "src": require("./assets/img/f2_a.png")
    },
    slot: "icon"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("发票夹")])]), _vm._v(" "), _c('tabbar-item', {
    attrs: {
      "link": "/user/"
    }
  }, [_c('img', {
    staticClass: "dsel_img",
    attrs: {
      "slot": "icon",
      "src": require("./assets/img/f3.png")
    },
    slot: "icon"
  }), _vm._v(" "), _c('img', {
    staticClass: "sel_img",
    attrs: {
      "slot": "icon",
      "src": require("./assets/img/f3_a.png")
    },
    slot: "icon"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("我的信息")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44423940"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 332
// module chunks = 0